import { client } from "../client";

/**
 * One-tap whitelist request for first-time players on Court of Attrition.
 * Sends "/whitelist <discord username>" to OOC and remembers the username
 * locally, so on later sessions (the browser reloads them as a new client
 * each time) the field is already filled and they just press the button.
 * Players auto-whitelisted by IPID never need it; the control is present
 * but unobtrusive.
 */
const STORAGE_KEY = "webcoa_whitelist_username";

export function sendWhitelistRequest() {
  const input = <HTMLInputElement>document.getElementById("whitelist_username");
  if (!input) return;
  const username = input.value.trim();
  if (!username) {
    input.focus();
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, username);
  } catch (e) { /* private mode */ }
  client.sender.sendOOC(`/whitelist ${username}`);
}

/** Restore the saved username into the field on load. */
export function initWhitelistField() {
  const input = <HTMLInputElement>document.getElementById("whitelist_username");
  if (!input) return;
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) input.value = saved;
  } catch (e) { /* ignore */ }
}

window.sendWhitelistRequest = sendWhitelistRequest;
window.initWhitelistField = initWhitelistField;

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initWhitelistField);
} else {
  initWhitelistField();
}
